"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
exports.default = (eventTarget, events, initialValue, getValue) => {
    const [value, setValue] = react_1.useState(initialValue);
    react_1.useEffect(() => {
        const handle = () => setValue(getValue());
        handle();
        events.forEach((eventType) => eventTarget.addEventListener(eventType, handle));
        return () => {
            events.forEach((eventType) => eventTarget.removeEventListener(eventType, handle));
        };
    }, []);
    return value;
};
